import { Component, OnInit,Output,EventEmitter,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { PowerUserRoleFormData, PowerUserRoles } from '../../../Models/user-profiles.model';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { SubjectList } from '../../../Models/user-profiles.model';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import {SessionService} from '../../../Services/session.service';
import { IGetCodes } from 'src/app/interfaces/codes';

@Component({
  selector: 'app-assign-roles-to-power-user',
  templateUrl: './assign-roles-to-power-user.component.html',
  styleUrls: ['./assign-roles-to-power-user.component.scss']
})
export class AssignRolesToPowerUserComponent implements OnInit {
  @Output() Closepopup: EventEmitter<any> = new EventEmitter<any>();
  //@Output() Closepopup:EventEmitter<any> =new EventEmitter<any>();
  //Close:Subject<any> = new Subject();
  selectRole: any[];
  roleStatus: any[];
  subjectType: any[];
  values: any[]= [];
  subjectListArray: any[] = [];
  subjectNames: string = "";
  assignUserRoles: any;
  userRole: any;
  closemodalpopup:any
  todayDate:Date = new Date();


  assignRoleToPowerUser = new FormGroup({
    startDate: new FormControl('', Validators.required),
    primarySubject: new FormControl('', Validators.required),
    name: new FormControl(''),
    endDate: new FormControl(''),
    additionalSubject: new FormControl(''),
    PowerUserId: new FormControl(''),
    status: new FormControl(''),
    comment: new FormControl('')
  })

  constructor(public session:SessionService,public toastr: ToastrService, private router: Router, public userService: UserManagementService, public datepipe: DatePipe) {
    this.todayDate=new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
   }

  ngOnInit(): void {
    this.getExperienceType();
    this.getStatusType();
    this.getSubjectType();
    this.setFormData();
  }

  setFormData() {
    this.assignRoleToPowerUser.controls['PowerUserId'].setValue(this.userService.powerUserId)
    this.assignRoleToPowerUser.controls['status'].setValue(this.userService.userStatus)
    this.assignRoleToPowerUser.controls['name'].setValue(this.userService.userName)
  }

  OnClickSubmitRole() {
    this.POSTOnClickSubmitRole(this.assignRoleToPowerUser.value)
  }

  POSTOnClickSubmitRole(data: any) {
    var tempUserRole: PowerUserRoleFormData;
    if(this.userRole!=null&&this.userRole!='undefined'&&this.userRole!=''){

    }
    else{
      this.userRole="CW";
    }

    tempUserRole = ({
      powerUserRoleId: 0,
      powerUserId: data.PowerUserId,
      powerUserRoleType: this.userRole,
      startDate:this.datepipe.transform(data.startDate,'MM/dd/yyyy'),
      endDate:this.datepipe.transform(data.endDate,'MM/dd/yyyy'),
      comment: data.comment,
      statusType: "New",
      loggedInUser: this.session.getUser(),
      SubjectList: this.subjectListArray
    })

    this.assignUserRoles = tempUserRole
    console.log(tempUserRole)
    this.userService.createUserRole(this.assignUserRoles).subscribe(
      res => {
        console.log(res);
       
        this.toastr.success('Success!', 'UserRole Is Created!');
        
        // this.Close.next(1);
        this.Closepopup.emit(this.closemodalpopup);
        this.router.navigate(['User/Poweruserlist']);
        //this.dialog.closeAll();
        console.log(res)
      },
      error => {
       this.toastr.error('ERROR!',error.error.Message);
       // this.toastr.error(error.Message);
       // console.log(error)
        
      }
    )
  }
  RoleFlag:boolean=false;
  onRoleChange(event: any) {
    this.RoleFlag=true;

    this.userRole = event.target.value;

  }

  
data:any
  onPrimarySubjectChange(event: any) {
    var tempPrimarySubjectList: SubjectList;
    var eventArr = event.target.value.split(" ");

    tempPrimarySubjectList = ({
      powerUserSubjectId: 0,
      powerUserRoleId: 0,
      subjectId: eventArr[0],
      primarySubjectInd: "Y",

    })
    if(this.subjectListArray.length>0){
        this.subjectListArray.forEach((value) => {
          // if(value.primarySubjectInd=='Y'){
          //   this.subjectListArray.splice(index, 1);
          // }
          if(value.subjectId==eventArr[0]){
            this.duplicateflag=true;
          }
          
      });
      if(!this.duplicateflag){
        for(var i=0;i<this.subjectListArray.length;i++){
          if(this.subjectListArray[i].subjectId==this.currentdropdown){
            this.subjectListArray.splice(i,1);
          }
         }
        this.subjectNames = this.subjectNames + eventArr[1];
        this.subjectListArray.push(tempPrimarySubjectList);
      }
      else{
        for(var i=0;i<this.subjectListArray.length;i++){
          if(this.subjectListArray[i].subjectId==this.currentdropdown){
            this.subjectListArray.splice(i,1);
          }
         }
         this.duplicateflag=false;
        this.subjectalertpopup('Y');
      }
    }
    else{
      this.subjectNames = this.subjectNames + eventArr[1];
            this.subjectListArray.push(tempPrimarySubjectList);
   }
    
    
    // this.subjectType.map((subject: {
    //   Code: any;
    //   subjectId: any; Checked: any;})=> {
    //   return subject.Checked =this.subjectListArray.some(fitler => fitler.subjectId == subject.Code);
    // });
    
   
  }
  filtersubjectDropdown(){
    this.subjectType.map((subject: {
      Code: any;
      subjectId: any; Checked: any;})=> {
      return subject.Checked =this.subjectListArray.some(fitler => fitler.subjectId == subject.Code);
    });
    var tempSubjectType: any[] = []
    for (let item of this.subjectType) {
      if (!item.Checked) {
        tempSubjectType.push({
          Code: item.Code,
          Name: item.Name
        })
      }
  }
    

    this.subjectType = tempSubjectType;

  console.log(this.subjectType)
  }

  currentdropdown:any;
  getvalue(event: any){
    this.currentdropdown = event.target.value;
    console.log(this.currentdropdown,'currentdropdown')
  }
  duplicateflag:boolean
  SecondarySubjectlist:any[]=[];
  onAdditionalSubjectChange(event: any,value:any) {

    var tempAdditionalSubjectList: SubjectList;
    var eventArr = event.target.value.split(" ");

    // tempAdditionalSubjectList = ({
    //   powerUserSubjectId: 0,
    //   powerUserRoleId: 0,
    //   subjectId: eventArr[0],
    //   primarySubjectInd: "N",
    // })
   

    if(this.subjectListArray.length>0){
      this.subjectListArray.forEach((value, index) => {
        if(value.subjectId==eventArr[0]){
          this.duplicateflag=true;
        
        }
    });
    if(!this.duplicateflag){
      if(this.values[value].PowerUserSubjectId>0){
        tempAdditionalSubjectList = ({
          powerUserSubjectId: this.values[value].PowerUserSubjectId,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
      else{
        tempAdditionalSubjectList = ({
          powerUserSubjectId: 0,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
      for(var i=0;i<this.subjectListArray.length;i++){
        if(this.subjectListArray[i].subjectId==this.currentdropdown){
          this.subjectListArray.splice(i,1);
        }
       }
      this.subjectNames = this.subjectNames + eventArr[1];
      this.subjectListArray.push(tempAdditionalSubjectList);
    }
    else{
      for(var i=0;i<this.subjectListArray.length;i++){
        if(this.subjectListArray[i].subjectId==this.currentdropdown){
          this.subjectListArray.splice(i,1);
        }
    }
      this.duplicateflag=false;
      this.subjectalertpopup(value);
    }
  }
  else{
    if(this.values[value].PowerUserSubjectId>0){
      tempAdditionalSubjectList = ({
        powerUserSubjectId: this.values[value].PowerUserSubjectId,
        powerUserRoleId: this.userService.powerUserRoleID,
        subjectId: eventArr[0],
        primarySubjectInd: "N",
      })
    }
    else{
      tempAdditionalSubjectList = ({
        powerUserSubjectId: 0,
        powerUserRoleId: this.userService.powerUserRoleID,
        subjectId: eventArr[0],
        primarySubjectInd: "N",
      })
    }
    this.subjectNames = this.subjectNames + eventArr[1];
          this.subjectListArray.push(tempAdditionalSubjectList);
  }
  }

  clearform(){
    
   if(this.Indexvalue!='Y'){
    this.values[this.Indexvalue].Code="";
    this.values[this.Indexvalue].PowerUserSubjectId=0;
    this.subjectalertpopup(1);
   }
   else{
    this.assignRoleToPowerUser.controls['primarySubject'].setValue("");
    this.subjectalertpopup(1);
   }
   
  }

  subjectalertflag:boolean
  Indexvalue:any
 subjectalertpopup(index:any){
   this.Indexvalue=index;
   this.subjectalertflag=!this.subjectalertflag;
 }


  DataUpdateFlag:boolean=false;
  OnClickCancelButton() {
    //this.Closepopup.emit(this.closemodalpopup);
    this.Editformvalidation();
    if(this.DataUpdateFlag){
      this.AlertCancelpopup();
    }
    else{
     this.DiscardChanges();
    }
  }

  Cancelalertpopup:boolean
  AlertCancelpopup(){
    this.Cancelalertpopup=!this.Cancelalertpopup;
  }

  DiscardChanges(){
    this.AlertCancelpopup();
     this.Closepopup.emit(this.closemodalpopup);
  }

  OnClickChangeStatus() {
    this.router.navigate(['/changeUserRoleStatus']);
    //this.dialog.closeAll();
  }

  getSubjectType() {
    this.userService.getSubject('SUBJECT').subscribe(
      res => {
        // console.log(res)
        this.getSubjectTypeResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getSubjectTypeResponse(data: IGetCodes[]) {
    var tempSubjectType: any[] = []
    data.forEach((element: IGetCodes) => {
      tempSubjectType.push({
        Code: element.Code,
        Name: element.Description
      })
    });

    this.subjectType = tempSubjectType;
    this.subjectType.map((obj: {Checked: any;}) => {
      obj.Checked = false;
      return obj;
      })
  }

  // filterUser(subject: any) {
  //   return !subject.Checked;
  // }


  getExperienceType() {
    this.userService.getCodes('POWER_USER_ROLE_TYPE').subscribe(
      res => {
        this.getRoleTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getRoleTypeResponse(data: any) {
    var tempRoleType: any[] = []
    console.log(data)
    data.forEach((element: { Code: any; Name: any; }) => {
      tempRoleType.push({
        Code: element.Code,
        Name: element.Name
      })

    });



    this.selectRole = tempRoleType;
    // console.log(this.selectRole)
  }

  getStatusType() {
    this.userService.getCodes('POWER_USER_ROLE_STATUS_TYPE').subscribe(
      res => {
        this.getStatusTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getStatusTypeResponse(data:any) {
    var tempRoleStatusType: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempRoleStatusType.push({
        Code: element.Code,
        Name: element.Name
      })

    });
    this.roleStatus = tempRoleStatusType;
  }


  removevalue(i:any) {
    for(var j=0;j<this.subjectListArray.length;j++){
      if(this.subjectListArray[j].subjectId==this.values[i].Code){
        this.subjectListArray.splice(j,1);
      }
    }
    this.values.splice(i, 1);
  }

  addvalue() {
    this.values.push({ Code: "",PowerUserSubjectId:0});
    
  }

  error:any={isError:false,errorMessage:''};
  compareEndDates(){
    //this.Editformvalidation();
    if(new Date(this.assignRoleToPowerUser.controls['endDate'].value)<new Date(this.assignRoleToPowerUser.controls['startDate'].value)){
       this.error={isError:true,errorMessage:'End Date cant before start date'};
    }
    else{
      this.error={isError:false,errorMessage:''};
    }
   }

   error1:any={isError:false,errorMessage:''};
   compareStartDates(){
     //this.Editformvalidation();
     if(new Date(this.assignRoleToPowerUser.controls['startDate'].value)<new Date(this.todayDate.setDate(this.todayDate.getDate()))){
        this.error1={isError:true,errorMessage:'Start Date cant before current date'};
     }
     else{
       this.error1={isError:false,errorMessage:''};
     }
     this.compareEndDates();
  //  if(this.ResourceAssignform.controls['StartDate'].value==this.SubjectRoleID.Start_Date){
  //    this.error1={isError:false,errorMessage:''};
  //  }
   //this.Editformvalidation();
    }


    Editformvalidation()
    {
      
   
    
      //if(this.powerUserRegistrationForm.valid){
      var startDate = this.assignRoleToPowerUser.controls['startDate'].value;
      var endDate = this.assignRoleToPowerUser.controls['endDate'].value;
      var primarySubject = this.assignRoleToPowerUser.controls['primarySubject'].value;
      var name = this.assignRoleToPowerUser.controls['name'].value;
      var additionalSubject = this.assignRoleToPowerUser.controls['additionalSubject'].value;
      var PowerUserId = this.assignRoleToPowerUser.controls['PowerUserId'].value;
      var comment = this.assignRoleToPowerUser.controls['comment'].value;
      var status = this.assignRoleToPowerUser.controls['status'].value;
      var userRole=this.userRole;
      var subjectListArray=this.subjectListArray;
      // if(Comment_Text==""){
      //   Comment_Text=null;
      // }
     
      if(startDate!=null&&startDate!=''&&startDate!='undefined')
      this.DataUpdateFlag=true;
      else if(endDate!=null&&endDate!=''&&endDate!='undefined')
      this.DataUpdateFlag=true;
      else if(primarySubject!=null&&primarySubject!=''&&primarySubject!='undefined')
      this.DataUpdateFlag=true;
      // else if(name!=null&&name!=''&&name!='undefined')
      // this.DataUpdateFlag=true;
      else if(additionalSubject!=null&&additionalSubject!=''&&additionalSubject!='undefined')
      this.DataUpdateFlag=true;
      // else if(PowerUserId!=null&&PowerUserId!=''&&PowerUserId!='undefined')
      // this.DataUpdateFlag=true;
      else if(comment!=null&&comment!=''&&comment!='undefined')
      this.DataUpdateFlag=true;
      // else if(status!=null&&status!=''&&status!='undefined')
      // this.DataUpdateFlag=true;
      else if(userRole!=null&&userRole!=''&&userRole!='undefined'&&this.RoleFlag)
      this.DataUpdateFlag=true;
      else if(subjectListArray.length>0)
      this.DataUpdateFlag=true;
      else
      this.DataUpdateFlag=false;
  
     //}
  
     
  }
 


}
